export default __webpack_public_path__ + "assets/images/discord.7224c150.png";